import axios from 'axios'

export default {
    getCdkeyList({commit}, params){
        return axios.post('/api/background/device/activation/list', params)
    },
    useCdkey({commit}, params){
        return axios.post('/api/background/device/modify', params)
    },
    getCdkey({commit}, params){
        return axios.post('/api/background/device/activation/get', params)
    },
    addDevice({commit}, params){
        return axios.post('/api/background/device/add', params)
    },
    modifyCdkey({commit}, params){
        return axios.post('/api/background/device/activation/status/modify', params)
    },
    deleteCdkey({commit}, params){
        return axios.post('/api/background/device/activation/status/delete', params)
    }
}


// WEBPACK FOOTER //
// ./src/vuex/actions/device.js